export function moneyFormat(amount: string | number) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount))
}

const currencySymbols: Record<string, string> = {
  GTQ: "Q",
  DOP: "RD$",
  USD: "US$",
}

export function formatMoneyWithCurrency(amount: string | number, currency?: string) {
  const symbol = currency ? currencySymbols[currency] || "US$" : "US$"
  return `${symbol} ${moneyFormat(amount)}`
}
